import styled, { css } from 'styled-components';

export const Wrapper = styled.li`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  width: 100%;
`;

export const CardWrapper = styled.div`
  ${({ theme, imageError }) => css`
    align-items: center;
    aspect-ratio: 4/5;
    border: 1px solid ${theme.v2.colors.neutral.highLight};
    border-radius: 16px;
    box-shadow: ${theme.v2.shadows.light};
    display: flex;
    justify-content: center;
    overflow: hidden;
    position: relative;
    transition: .2s;
    width: 100%;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: ${theme.v2.colors.brand.primaryExtraDark};
      opacity: 0;
      transition: 0.3s;
      pointer-events: none;
      z-index: 1;
    }

    &:hover::after {
      opacity: 80%;
    }

    &:hover {
      box-shadow: ${theme.v2.shadows.dark};
    }

    ${imageError && css`
      border-color: #F9F9F9;
      box-shadow: none;
    `}
  `};
`;

export const SkeletonWrapper = styled.div`
  ${({ $loaded }) => css`
    height: 100%;
    position: absolute;
    transition: .3s ease-in-out;
    width: 100%;

    ${$loaded ? css`
      opacity: 0;
    ` : css`
      opacity: 1;
    `}
  `};
`;

export const CardImage = styled.img`
  ${({ $loaded }) => css`
    display: block;
    height: 100%;
    object-fit: cover;
    object-position: top;
    transition: .3s ease-in-out;
    width: 100%;

    ${$loaded ? css`
      filter: blur(0px);
      opacity: 1;
    ` : css`
      filter: blur(8px);
      opacity: 0;
    `}
  `}
`;

export const OverlayWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: .2s;
  width: 100%;
  z-index: 2;

  &:hover {
    opacity: 1;
  }
`;

export const OverlayContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  width: fit-content;

  & button {
    width: 100%;
  }
`;

export const CardTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    text-align: center;
  `};
`;

export const CardError = styled.div`
  ${({ theme }) => css`
    background: #F9F9F9;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      flex: 0 0 68px;
      height: 68px;
      width: 68px;
    }
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      svg {
        flex: 0 0 40px;
        height: 40px;
        width: 40px;
      }
    }
  `}
`;
